export default __webpack_public_path__ + "static/media/cheers-tears-pepe.64d3de15.jpeg";